module.exports = __webpack_public_path__ + "img/tech_6.90330cc5.png";